import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ts0005',
    ecrans: ['00-2'],
    params:['?eplnomprn','?demcleint']
});
